import styled from "@emotion/styled";

interface ErrorBadgeProps {
  size?: "sm" | "md";
}

const SIZES = {
  sm: { width: 16, height: 16, fontSize: 10 },
  md: { width: 20, height: 20, fontSize: 11 },
};

const ErrorBadge = styled.span<ErrorBadgeProps>(({ size = "md" }) => {
  const s = SIZES[size];
  return {
    width: s.width,
    height: s.height,
    borderRadius: "50%",
    backgroundColor: "#DC2626",
    color: "#fff",
    fontSize: s.fontSize,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    lineHeight: 1,
  };
});

export default ErrorBadge;
